<template>
    <div class="content" style="position: relative;">
        <div class="row">
            <div class="col-md-10 flex-container-top">
                <h2 class="text-eveer">Credits Transactions List</h2>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <card card-body-classes="table-full-width">
                    <!-- <h4 slot="header" class="card-title">Credits Transactions list</h4> -->
                    <div>
                        <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                            <el-select class="select-primary mb-3 pagination-select" v-model="pagination.perPage"
                                placeholder="Per page">
                                <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item"
                                    :label="item" :value="item" />
                            </el-select>
                            <base-input>
                                <el-input type="search" class="mb-3 search-input" clearable prefix-icon="el-icon-search"
                                    placeholder="Search records" v-model="searchQuery" aria-controls="datatables" />
                            </base-input>
                        </div>
                        <el-table :data="tableData" style="font-size: 13px">
                            <el-table-column :min-width="150" align="left" label="Name">
                                <div slot-scope="props">
                                    <div style="font-weight: 300;">
                                        {{ props.row.user.first_name }} {{ props.row.user.last_name }}
                                    </div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" label="No. of Credits">
                                <div slot-scope="props">
                                    <div style="font-weight: 300;">
                                        {{ props.row.dropin_money }}
                                    </div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" label="Time">
                                <div slot-scope="props">
                                    <div>{{ getBookingDateTime(props.row.created_at) }}</div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" label="Type">
                                <div slot-scope="props">
                                    <div>{{ props.row.type }}</div>
                                </div>
                            </el-table-column>
                            <el-table-column :min-width="200" align="left" label="Transaction Type">
                                <div slot-scope="props">
                                    <div>{{ props.row.transaction_type }}</div>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
                        <div>
                            <p class="card-category">
                                Showing {{ from }} to {{ to }} of {{ pagination.total }} entries
                            </p>
                        </div>
                        <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
                            :per-page="pagination.perPage" :total="pagination.total" />
                    </div>
                </card>
            </div>
        </div>

        <div class="row loader-pos" v-if="loading">
            <div class="sk-chase">
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
                <div class="sk-chase-dot"></div>
            </div>
            <div class="no-data-message" v-if="noDataMessage">
                <div>There are no records found</div>
            </div>
        </div>
        <div v-if="loading" class="global-loading-overlay"></div>
    </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "src/components";
import Fuse from "fuse.js";
import moment from "moment";
import debounce from 'lodash/debounce';

export default {
    components: {
        BasePagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn
    },
    data() {
        return {
            role: localStorage.getItem("role"),
            noDataMessage: false,
            loading: false,
            pagination: {
                perPage: 10,
                currentPage: 1,
                perPageOptions: [10, 50, 100, 1000],
                total: 0
            },
            searchQuery: "",
            tableData: [],
            searchedData: [],
            fuseSearch: null
        };
    },
    computed: {
        from() {
            return this.tableData.length === 0 ? 0 : (this.pagination.currentPage - 1) * this.pagination.perPage + 1;
        },
        to() {
            return this.from + this.tableData.length - 1;
        }
    },
    watch: {
        "pagination.currentPage"() {
            this.LoadCreditsTransactions();
        },
        "pagination.perPage"() {
            this.pagination.currentPage = 1;
            this.LoadCreditsTransactions();
        },
        searchQuery() {
            this.pagination.currentPage = 1;
            this.debouncedLoadCreditsTransactions();
        }
    },
    mounted() {
        this.LoadCreditsTransactions();
    },
    methods: {
        getBookingDateTime(date) {
            return moment(date).format("MMMM Do YYYY, h:mm:ss a");
        },
        debouncedLoadCreditsTransactions: debounce(function () {
            this.LoadCreditsTransactions();
        }, 1000),
        async LoadCreditsTransactions() {
            this.loading = true;
            const { currentPage, perPage } = this.pagination;

            const res = await this.$apiService.getCall(`userdropinmoney/all-users-dropin-transactions?page=${currentPage}&limit=${perPage}&search=${this.searchQuery}`);
            
            const { Code, Data, total, page, Message } = res.apidata;

            if (Code === "P00001") {
                this.tableData = Data || [];
                this.pagination.total = total;
                this.pagination.currentPage = page;
                this.noDataMessage = this.tableData.length === 0;
            } else {
                this.$apiService.notify(Message);
            }
            this.loading = false;
        }
    }
};
</script>

<style>
.pagination-select,
.search-input {
    width: 200px;
}

.swal2-icon-content {
    font-size: inherit !important;
}

.group-img {
    width: 100%;
    max-width: 100px;
    height: 150px;
    border-radius: 50%;
    object-fit: cover;
}

.icon-padding {
    padding: 10px;
}

.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  pointer-events: all;
}
</style>